import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { Col, Row, Input, Form, Divider, Upload, Collapse, notification } from 'antd';

import { useResizeObserver } from 'usehooks-ts';
import { useAppDispatch } from '@store/hooks';

import FormHeader from '@controls/form-header/form-header';
import IBaseComponentProps from '@components/base-component-props';

import Consignments from '@flp/components/warehouse/consignments/consignments';

import { userLoaded } from '@store/actions';

import { exception } from '@extensions/notification';

import { ITruck } from '@entities/truck';

import { TruckStatus } from '@enums/truck-status';

const Truck = (props: IBaseComponentProps) => {
    const { serverFetch } = props;

    const Buffer = require('buffer/').Buffer;

    const { TextArea } = Input;

    const { id } = useParams();

    const detailsRef = useRef<HTMLDivElement>(null);
    const { width: detailsWidth = 0, height: detailsHeight = 0 } = useResizeObserver({
        ref: detailsRef,
        box: 'border-box',
    });

    const d = useAppDispatch();

    const [api, contextHolder] = notification.useNotification();

    const [truck, setTruck] = useState<ITruck>();
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        initData();
    }, []);

    const initData = async () => {
        if (!id) {
            setTruck(undefined);
            return;
        }

        setLoading(true);

        serverFetch(`trucks/${id}`, { method: 'GET' })
            .then((data: ITruck) => {
                setTruck(data);
                setLoading(false);
            })
            .catch((ex: any) => {
                setLoading(false);
                exception(api, 'Ошибка получения машины', ex, () => d(userLoaded(undefined)));
            });
    };
    const onDownload = async (id: string): Promise<any> => {
        return serverFetch(`documents/${id}/download`, { method: 'GET' })
            .then((data: any) => {
                return data;
            })
            .catch((ex: any) => {
                exception(api, 'Ошибка загрузки файла', ex, () => d(userLoaded(undefined)));
                return undefined;
            });
    };

    const handlePreview = async (file: any) => {
        if (file) {
            if (!file.url && !file.preview) {
                const result = await onDownload(file.uid);

                file.originFileObj = result.fileContents;
                file.contentType = result.contentType;
                file.name = result.fileDownloadName;

                let fileObj = file.originFileObj;

                if (typeof fileObj !== 'object') {
                    const buffer = new Buffer.from(file.originFileObj, 'base64');
                    fileObj = new Blob([buffer], { type: file.contentType });
                }

                const fileURL = URL.createObjectURL(fileObj);
                window.open(fileURL);
            }
        }
    };

    return (
        <>
            <Row>
                <FormHeader title={`Приемка машины "${truck?.number}"`} />
            </Row>

            <div>
                <div ref={detailsRef}>
                    <Collapse
                        defaultActiveKey='details'
                        style={{ marginBottom: 20 }}
                        items={[
                            {
                                key: 'details',
                                label: 'Детали',
                                children: (
                                    <Row style={{ marginBottom: 10 }}>
                                        <Col span={11}>
                                            <Form colon={false} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                                <Form.Item label='Номер машины' wrapperCol={{ span: 5 }}>
                                                    <Input disabled={true} value={truck?.number} />
                                                </Form.Item>
                                                <Form.Item label='Комментарий'>
                                                    <TextArea rows={8} disabled={true} value={truck?.comment} />
                                                </Form.Item>
                                            </Form>
                                        </Col>

                                        <Col offset={1} span={12}>
                                            <>
                                                {truck?.documents && truck.documents.length > 0 && (
                                                    <>
                                                        <Divider titlePlacement='left' style={{ marginTop: 0 }}>
                                                            Документы для клиентов
                                                        </Divider>
                                                        <Form.Item
                                                            wrapperCol={{ span: 24 }}
                                                            style={{
                                                                textAlign: 'left',
                                                                marginTop: 10,
                                                                border: '1px solid #d9d9d9',
                                                                borderRadius: 5,
                                                                padding: 5,
                                                                height: 100,
                                                                overflow: 'auto',
                                                            }}
                                                        >
                                                            <Upload
                                                                onPreview={handlePreview}
                                                                listType='text'
                                                                multiple
                                                                fileList={truck.documents}
                                                            />
                                                        </Form.Item>
                                                    </>
                                                )}

                                                {truck?.internalDocuments && truck.internalDocuments.length > 0 && (
                                                    <>
                                                        <Divider
                                                            titlePlacement='left'
                                                            style={{ marginTop: 20, backgroundColor: 'var(--main-red)' }}
                                                        >
                                                            Документы для внутреннего использования
                                                        </Divider>
                                                        <Form.Item
                                                            wrapperCol={{ span: 24 }}
                                                            style={{
                                                                textAlign: 'left',
                                                                marginTop: 10,
                                                                border: '1px solid #d9d9d9',
                                                                borderRadius: 5,
                                                                padding: 5,
                                                                height: 100,
                                                                overflow: 'auto',
                                                            }}
                                                        >
                                                            <Upload
                                                                onPreview={handlePreview}
                                                                listType='text'
                                                                multiple
                                                                fileList={truck.internalDocuments}
                                                            />
                                                        </Form.Item>
                                                    </>
                                                )}
                                            </>
                                        </Col>
                                    </Row>
                                ),
                            },
                        ]}
                    />
                </div>

                {id && (
                    <Consignments
                        detailsHeight={detailsHeight}
                        truckId={id}
                        viewOnly={truck?.status === TruckStatus.Finished || truck?.status === TruckStatus.Cancelled}
                        serverFetch={serverFetch}
                    />
                )}
            </div>

            {contextHolder}
        </>
    );
};

export default Truck;
